import { literal, object, union } from 'superstruct';
import { DUPLICATE_USER_EMAIL } from './add-user.dto';
export const UserErrorDto = union([object({
  message: literal(DUPLICATE_USER_EMAIL)
})]);